'use strict';

var noUiSlider = require('nouislider');
var wNumb = require('wnumb');
var extend = require('extend');

function init(config) {
	/** @type {{element: string, min: number, max: number, minField: string, maxField: string}} */
	var config = extend({}, {
		element: 'rangeSlide',
		min: 0,
		max: 100,
		minField: 'minField',
		maxField: 'maxField',
		step: 1
	}, config);

	var rangeInput = document.getElementsByClassName(config.element)[0];
	if (!rangeInput)
		return;

	var numbFormat = wNumb({ decimals: 0});
	noUiSlider.create(rangeInput, {
		start: [config.min, config.max],
		connect: true,
		step: config.step,
		snap: false,
		range: {
			'min': config.min,
			'max': config.max
		},
		tooltips: [numbFormat, numbFormat]
	});

	var handles = document.querySelectorAll('.noUi-handle');

	// Create 'Min'/'Max' Labels
	var minMaxEl = {
		min: document.createElement('div'),
		max: document.createElement('div')
	}
	minMaxEl.min.classList.add('noUi-label', 'noUi--min');
	minMaxEl.max.classList.add('noUi-label', 'noUi--max');
	var minText = document.createTextNode('min')
	minMaxEl.min.appendChild(minText);
	handles[0].appendChild(minMaxEl.min);
	var maxText = document.createTextNode('max')
	minMaxEl.max.appendChild(maxText);
	handles[1].appendChild(minMaxEl.max);

	// Listen for keypress on handles
	handles.forEach(function(element, index) {
		element.addEventListener('keydown', function(event) {
			// Get current max and min
			var minValue = parseInt(rangeInput.noUiSlider.get()[0], 10);
			var maxValue = parseInt(rangeInput.noUiSlider.get()[1], 10);

			if (index) {
				// Max
				switch (event.which) {
					case 37:
						rangeInput.noUiSlider.set([minValue, maxValue - 1]);
						break;
					case 39:
						rangeInput.noUiSlider.set([minValue, maxValue + 1]);
						break;
				}
			} else {
				// Min
				switch (event.which) {
					case 37:
						rangeInput.noUiSlider.set([minValue - 1, maxValue]);
						break;
					case 39:
						rangeInput.noUiSlider.set([minValue + 1, maxValue]);
						break;
				}
			}
		});
	});

	// Update inputs
	var minField = document.getElementsByClassName(config.minField)[0];
	var maxField = document.getElementsByClassName(config.maxField)[0];
	if (minField || maxField) {
		rangeInput.noUiSlider.on('update', function(values, handle) {
			if (handle && maxField) {
				maxField.setAttribute('value', numbFormat.to(parseInt(values[handle], 10)));
			} else if (!handle && minField) {
				minField.setAttribute('value', numbFormat.to(parseInt(values[handle], 10)));
			}
		});
	}
}

module.exports = {
	init: init
};
